module.exports = __webpack_public_path__ + "static/img/item-l_j_tropical.1fa72e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/item-l_j_tropical.png
// module id = /SD7
// module chunks = 1